<wbo-search-page (editing)="editing($event)">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="fromDate">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="toDate">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control initialDefaultValue="-1">
                    <wbo-select-options>
                        <wbo-select-option [value]="'-1'" label="wbo.cash-management.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option [value]="'1'" label="wbo.cash-management.option.status.balanced">
                        </wbo-select-option>
                        <wbo-select-option [value]="'2'" label="wbo.cash-management.option.status.closed">
                        </wbo-select-option>
                        <wbo-select-option [value]="'0'" label="wbo.cash-management.option.status.open">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'terminal'">
                <wbo-terminal-multi-select-search-control></wbo-terminal-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="terminal"></wbo-main-search-column>
        <wbo-date-time-column field="floatStart"></wbo-date-time-column>
        <wbo-currency-column field="floatIn"></wbo-currency-column>
        <wbo-date-time-column field="floatEnd"></wbo-date-time-column>
        <wbo-date-time-column field="firstBalanceDate"></wbo-date-time-column>
        <wbo-column field="startUser"></wbo-column>
        <wbo-column field="endUser"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-column field="verifyUser"></wbo-column>
        <wbo-actions-search-column>
            <wbo-brief-till-summary-report-search-action></wbo-brief-till-summary-report-search-action>
            <wbo-cash-management-verify-balance-search-action></wbo-cash-management-verify-balance-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
